window.linkReferencesJs = window.linkReferencesJs || {
  isInitialized: false,

  setLinkReferencesOpenersHandlers: () => {
    const linkReferencesOpeners = [...document.querySelectorAll('.arjo-o-link-references__opener')];

    const toggleOpenComponent = (targetOpener) => {
      const linkReferences = targetOpener.closest('.arjo-o-link-references');
      linkReferences.classList.toggle('arjo-o-link-references--opened');
    };

    const linkReferencesOpenerClickHandler = (e) => {
      const targetOpener = e.target.closest('.arjo-o-link-references__opener');
      toggleOpenComponent(targetOpener);
    };

    linkReferencesOpeners.forEach((linkReferencesOpener) => {
      linkReferencesOpener.addEventListener('click', (e) => {
        linkReferencesOpenerClickHandler(e);
      });
    });
  },

  init: function () {
    const _this = window.linkReferencesJs;
    if (_this.isInitialized) {
      return;
    }
    _this.isInitialized = true;

    _this.setLinkReferencesOpenersHandlers();
  },
};

window.addEventListener('load', function () {
  window.linkReferencesJs.init();
});
